import axios from 'axios'
import { rolesAuth } from '@/modules/constants/roles'
import { store } from '@/store'
import { useAlert } from '@/modules/composition/useAlert'
const apiAuth = axios.create({
	baseURL: window.location.origin + '/api'
})

const { errorAlert } = useAlert()

export const getToken = async (login, password) => {
	console.log('get token')
	await apiAuth.post('/auth/login', new URLSearchParams({ login, password }))
		.then((response) => {
			if (response.status === 200 && response.data) {
				setAccount(response.data)
				setToken(response.headers.authorization)
				return response.headers.authorization
			}
		})
		.catch((error) => {
			console.error(error)
			errorAlert('Ошибка авторизации')
			return null // или обрабатывайте ошибку как вам удобно
		})
}
const setAccount = (data) => {
	store.commit('setLoading', true, { root: true })
	const { id, organization, surname, name, middleName, login, authorities } = data
	if (login) {
		const roles = {}
		let isAdmin = false
		authorities.forEach(ROLE => {
			roles[ROLE.name] = rolesAuth[ROLE.name] === null
			if (ROLE.name === 'ADMIN' || ROLE.name === 'FACTORY') isAdmin = true // TODO: предусмотреть ролевую модель
		})

		localStorage.account = JSON.stringify({ id, login, surname, name, middleName, roles, isAdmin, organization, authorities })
	}

	if (!localStorage.account) {
		document.location.href = '/' // Перенаправляем на страницу авторизации при получении статуса 401
	}
}

export const setToken = (token) => {
	window.localStorage.removeItem('access_token')
	window.localStorage.setItem('access_token', token)
}

export const clearToken = () => {
	window.localStorage.removeItem('access_token')
	window.localStorage.removeItem('account')
}
